import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracaoEmolumento/';

class Declaracao {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllDeclaracoes(idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allDeclaracoes?idContribuinte='+idContribuinte+'&ano='+ano+'&mes='+mes, {headers: this.headers});
    }

    declarar(idCliente, idUsuario, idContribuinte, ano, mes, tipo, emolumentos){
        return axios.post(API_URL+'declaracaoEmolumento?idCliente='+idCliente+'&idContribuinte='+idContribuinte+'&idUsuario='+idUsuario+'&ano='+ano+'&mes='+mes+'&tipo='+tipo, JSON.stringify(emolumentos),
        {headers: this.headers});
    }

    upload(idCliente, idUsuario, idContribuinte, file) {
        const formData = new FormData()
        formData.append('file', file, file.name)
        return axios.post(API_URL+'upload?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, formData, { headers: this.headers });
    }
    
}

export default new Declaracao();